import * as React from "react"

import { Container, Row, Col, Button } from "shards-react"
import { Img } from "react-image"
import Carousel from "react-bootstrap/Carousel"
import { StaticImage } from "gatsby-plugin-image"

// View Components
import MobileView from "../common/mobileView"
import BrowserView from "../common/browserView"

// Images & Videos
import CSECVideo from "../videos/csec.mp4"
import StudentImage from "../images/student.jpg"

import { getCountry } from "../js/getCountry"

// Icons
import BookIcon from "../images/icons/books.jpeg"
import UsersIcon from "../images/icons/users.png"
import CalendarIcon from "../icons/calendar"
import ZoomIcon from "../icons/zoom"
import StudentsIcon from "../icons/students"

class CsecPromotion extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      routes: require("../data/routes.json"),
      country: getCountry(this.props.countryCode)
    }

    this.routify = this.routify.bind(this)
  }

  routify(url) {
    return "/" + this.state.country.slug + url
  }

  render() {
    const Video = () => (
      <video
        style={{ width: "100%" }}
        preload="auto"
        autoPlay={true}
        loop
        muted
      >
        <source style={{ width: "100%" }} src={CSECVideo} type="video/mp4" />
      </video>
    )

    const Summary = () => (
      <Row>
        <Col xs={4}>
          <CalendarIcon />
          <p className="text-center p-2">
            <strong>Sept. 12</strong>
          </p>
        </Col>
        <Col xs={4}>
          <StudentsIcon />
          <p className="text-center p-2">
            <strong>Small Classes</strong>
          </p>
        </Col>
        <Col xs={4}>
          <ZoomIcon />
          <p className="text-center p-2">
            <strong>Online</strong>
          </p>
        </Col>
      </Row>
    )
    return (
      <div style={{ width: "100%" }}>
        <Row>
          <Col md={6}>
            <Video />
          </Col>
          <Col md={6}>
            <Container>
              <br />
              <h4 className="text-center">Join our Online CXC Classes</h4>

              <p className="text-center p-1">
                Registration for the May/ June 2023 exams are now open! Enroll
                online now and start learning from the comfort of your home.
              </p>

              <br />
              <Summary />

              <br />
              <Row>
                <Col xs={6}>
                  <Button
                    href={this.routify(this.state.routes.csec)}
                    style={{ width: "100%" }}
                  >
                    Register for CSEC
                  </Button>
                </Col>
                <Col xs={6}>
                  <Button
                    href={this.routify(this.state.routes.cape)}
                    outline
                    style={{ width: "100%" }}
                  >
                    Register for CAPE
                  </Button>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <br />
      </div>
    )
  }
}

export default CsecPromotion
